// ReportWrapper.tsx (tạo file mới)
import { useStudentDashboard } from '@hooks/useStudentDashboard';
import { useStudentPractice } from '@hooks/useStudentPractice';
import ReportChart from './index';

const ReportWrapper = () => {
    const {
        filterData,
        setFilterDataAction
    } = useStudentDashboard();
    
    const {
        studentClassModuleList,
    } = useStudentPractice();
    
    return (
        <ReportChart 
            filterData={filterData}
            setFilterDataAction={setFilterDataAction}
            studentClassModuleList={studentClassModuleList}
            useModuleFilter={true}
            useTimeFilter={true}
        />
    );
};

export default ReportWrapper;